const CategoryTypeEnum = Object.freeze({
    ECODE : 'e-code',
    PHYSICAL: 'physical'
})

export default CategoryTypeEnum;